import bongdanetInRedGif from "@/assets/images/bongdanet_in_red.gif";
import bongdanetFlagIcon from "@/assets/images/bongdanet_flag.svg";
import bongdanetBallIcon from "@/assets/images/bongdanet_ball.svg";
import bongdanetShirtIcon from "@/assets/images/bongdanet_shirt.svg";
import bongdanetLineupIcon from "@/assets/images/bongdanet_lineup.svg";

import { TrendOdd } from "./FootballOddsTrendOdds";

export default function FootballOddsDesktopRow({
  league,
  match,

  leagueBg,
  leagueShort,

  formattedGio,

  isLive,
  minuteText,

  currentHomeScore,
  currentAwayScore,
  currentHomeCorner,
  currentAwayCorner,
  homeYellow,
  homeRed,
  awayYellow,
  awayRed,

  h1Handicap,
  h1Ou,
  h11x2,
  ft,
  ft1x2,

  otherCount,
  handleOtherOddsClick,

  openTipsWithTab,
}) {
  return (
    <tr
      className={[
        "table_live",
        "bg-[var(--theme-foreground)]",
        "hidden md:table-row",
      ]
        .filter(Boolean)
        .join(" ")}
      id={`tb_${match?.id}`}
      data-league={league?.id ?? match?.league?.id ?? match?.leagueId ?? ""}
    >
      <td
        className="border-b border-solid border-[var(--theme-border)] border-x-0 border-t-0 p-0 align-middle text-center text-[13px] leading-[15px]"
        style={{ backgroundColor: leagueBg }}
      >
        <a
          className="block text-[10px] text-[var(--theme-on-primary)] no-underline hover:no-underline"
          href="#"
          rel="nofollow"
        >
          {leagueShort}
        </a>
      </td>

      <td className="football-live-time border-b border-solid border-[var(--theme-border)] border-x-0 border-t-0 bg-[var(--theme-foreground)] p-0 align-middle text-center text-[13px] leading-[15px]">
        {isLive ? (
          <>
            {minuteText || "Live"}
            <img
              className="inline-block align-middle"
              src={bongdanetInRedGif}
              alt=""
            />
          </>
        ) : (
          formattedGio
        )}
      </td>

      <td className="w-[18%] border-b border-solid border-[var(--theme-border)] border-x-0 border-t-0 bg-[var(--theme-foreground)] p-0 align-middle text-right text-[13px] leading-[15px]">
        <div className="flex w-full min-w-[132px] max-w-[140px] items-center justify-end">
          {Number(homeYellow ?? 0) > 0 && (
            <i className="inline-block">
              <i className="football-card-yellow mx-[2px] inline-block h-[17px] w-[12px] rotate-[7deg] rounded-[2px] px-[2px] text-center text-[12px] font-semibold leading-[17px] text-[var(--theme-text)]">
                {homeYellow}
              </i>
            </i>
          )}
          {Number(homeRed ?? 0) > 0 && (
            <i className="inline-block">
              <i className="football-card-red mx-[2px] inline-block h-[17px] w-[12px] rotate-[7deg] rounded-[2px] px-[2px] text-center text-[12px] font-semibold leading-[17px] text-[var(--theme-on-primary)]">
                {homeRed}
              </i>
            </i>
          )}
          <a
            className="name data-history-ls block no-underline hover:no-underline"
            href="javascript:void(0);"
            rel="nofollow"
          >
            {match.homeName}
          </a>
        </div>
      </td>

      <td className="w-[7%] border-b border-solid border-[var(--theme-border)] border-x-0 border-t-0 bg-[var(--theme-foreground)] p-0 align-middle text-center text-[13px] leading-[15px]">
        <div className="inline-block whitespace-nowrap rounded-[6px] bg-[var(--theme-foreground)] px-[6px] py-[3px]">
          <a
            className="font-bold text-[var(--theme-highlight,#0000FF)] no-underline hover:no-underline"
            href="#"
            rel="nofollow"
          >
            <span className="homeS">{currentHomeScore ?? 0}</span>
            <span className="home-vs-guest">-</span>
            <span className="guestS">{currentAwayScore ?? 0}</span>
          </a>
        </div>
      </td>

      <td className="w-[18%] border-b border-solid border-[var(--theme-border)] border-x-0 border-t-0 bg-[var(--theme-foreground)] p-0 align-middle text-left text-[13px] leading-[15px]">
        <div className="flex w-full min-w-[132px] max-w-[140px] items-center">
          <a
            className="name data-history-ls block no-underline hover:no-underline"
            href="javascript:void(0);"
            rel="nofollow"
          >
            <strong className="text-[12px] font-normal">{match.awayName}</strong>
          </a>
          {Number(awayRed ?? 0) > 0 && (
            <i className="inline-block">
              <i className="football-card-red mx-[2px] inline-block h-[17px] w-[12px] rotate-[7deg] rounded-[2px] px-[2px] text-center text-[12px] font-semibold leading-[17px] text-[var(--theme-on-primary)]">
                {awayRed}
              </i>
            </i>
          )}
          {Number(awayYellow ?? 0) > 0 && (
            <i className="inline-block">
              <i className="football-card-yellow mx-[2px] inline-block h-[17px] w-[12px] rotate-[7deg] rounded-[2px] px-[2px] text-center text-[12px] font-semibold leading-[17px] text-[var(--theme-text)]">
                {awayYellow}
              </i>
            </i>
          )}
        </div>
      </td>

      <td className="border-b border-solid border-[var(--theme-border)] border-x-0 border-t-0 bg-[var(--theme-foreground)] p-0 align-middle text-center text-[13px] leading-[15px]">
        <div className="mt-[2px] text-[12px] text-[var(--theme-text)]">
          <span>
            {currentHomeCorner ?? 0} - {currentAwayCorner ?? 0}
          </span>
        </div>
        <div className="football-trend-down mt-[2px] text-[12px]">
          <span className="odd">0</span> - <span className="odd">0</span>
        </div>
      </td>

      <td className="border-b border-solid border-[var(--theme-border)] border-x-0 border-t-0 bg-[var(--theme-foreground)] p-0 align-middle text-center text-[13px] leading-[15px]">
        <a
          className="inline-block"
          href="javascript:void(0)"
          rel="nofollow"
          onClick={openTipsWithTab("ai")}
        >
          <img
            src={bongdanetFlagIcon}
            width="16"
            height="16"
            title="Phân tích"
            alt="Phân tích"
          />
        </a>
        <a
          className="inline-block"
          href="javascript:void(0)"
          rel="nofollow"
          onClick={openTipsWithTab("odds")}
        >
          <img
            src={bongdanetBallIcon}
            width="16"
            height="16"
            title="So sánh"
            alt="So sánh"
          />
        </a>
        <a
          className="inline-block"
          href="javascript:void(0)"
          rel="nofollow"
          onClick={openTipsWithTab("h2h")}
        >
          <img
            src={bongdanetShirtIcon}
            width="16"
            height="16"
            title="Chi tiết"
            alt="Chi tiết"
          />
        </a>
        <a
          className="inline-block"
          href="javascript:void(0)"
          rel="nofollow"
          onClick={openTipsWithTab("form")}
        >
          <img
            src={bongdanetLineupIcon}
            width="16"
            height="16"
            title="Dữ liệu"
            alt="Dữ liệu"
          />
        </a>
      </td>

      <td className="w-[31%] min-w-[140px] border-b border-solid border-[var(--theme-border)] border-x-0 border-t-0 bg-[var(--theme-foreground)] p-0 align-middle text-center text-[12px] leading-[14px]">
        <div className="p-[4px]">
          <div className="grid grid-cols-[20px_1fr_1px_1fr_1px_1fr] grid-rows-[auto_auto_auto] items-center gap-x-[6px]">
            <div className="col-[3] row-[1/span_3] h-full w-[1px] bg-[var(--theme-border)]" />
            <div className="col-[5] row-[1/span_3] h-full w-[1px] bg-[var(--theme-border)]" />

            <div className="col-[2] row-[1] text-center text-[9px] leading-[10px] text-[var(--theme-text-muted)]">
              Chấp
            </div>
            <div className="col-[4] row-[1] text-center text-[9px] leading-[10px] text-[var(--theme-text-muted)]">
              Tài Xỉu
            </div>
            <div className="col-[6] row-[1] text-center text-[9px] leading-[10px] text-[var(--theme-text-muted)]">
              1x2
            </div>

            <div className="col-[1] row-[2] text-left text-[9px] leading-[10px] text-[var(--theme-text-muted)]">
              H1
            </div>
            <div className="col-[2] row-[2] flex items-center justify-between gap-[6px] tabular-nums">
              <TrendOdd value={h1Handicap.home} trend={h1Handicap.homeTrend} />
              <span className="text-[var(--theme-highlight,#0B71F9)] tabular-nums">
                {h1Handicap.line}
              </span>
              <TrendOdd value={h1Handicap.away} trend={h1Handicap.awayTrend} />
            </div>
            <div className="col-[4] row-[2] flex items-center justify-between gap-[6px] tabular-nums">
              <TrendOdd value={h1Ou.over} trend={h1Ou.overTrend} />
              <span className="text-[var(--theme-highlight,#0B71F9)] tabular-nums">
                {h1Ou.ouLine}
              </span>
              <TrendOdd value={h1Ou.under} trend={h1Ou.underTrend} />
            </div>
            <div className="col-[6] row-[2] flex items-center justify-between gap-[6px] tabular-nums">
              <TrendOdd value={h11x2.home} trend={h11x2.homeTrend} />
              <TrendOdd value={h11x2.draw} trend={h11x2.drawTrend} />
              <TrendOdd value={h11x2.away} trend={h11x2.awayTrend} />
            </div>

            <div className="col-[1] row-[3] text-left text-[9px] leading-[10px] text-[var(--theme-text-muted)]">
              TT
            </div>
            <div className="col-[2] row-[3] flex items-center justify-between gap-[6px] tabular-nums">
              <TrendOdd value={ft.home} trend={ft.homeTrend} />
              <span className="text-[var(--theme-highlight,#0B71F9)] tabular-nums">
                {ft.line}
              </span>
              <TrendOdd value={ft.away} trend={ft.awayTrend} />
            </div>
            <div className="col-[4] row-[3] flex items-center justify-between gap-[6px] tabular-nums">
              <TrendOdd value={ft.over} trend={ft.overTrend} />
              <span className="text-[var(--theme-highlight,#0B71F9)] tabular-nums">
                {ft.ouLine}
              </span>
              <TrendOdd value={ft.under} trend={ft.underTrend} />
            </div>
            <div className="col-[6] row-[3] flex items-center justify-between gap-[6px] tabular-nums">
              <TrendOdd value={ft1x2.home} trend={ft1x2.homeTrend} />
              <TrendOdd value={ft1x2.draw} trend={ft1x2.drawTrend} />
              <TrendOdd value={ft1x2.away} trend={ft1x2.awayTrend} />
            </div>
          </div>
        </div>

        <div className="pt-[2px] text-right text-[11px] text-[var(--theme-text-muted)]">
          <button
            type="button"
            className="border-0 border-none bg-transparent p-0 underline"
            onClick={handleOtherOddsClick}
          >
            Kèo khác +{otherCount}
          </button>
        </div>
      </td>
    </tr>
  );
}

